// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__RBtNK","gradient":"Button_gradient__lo72X","outlined":"Button_outlined__gq+aU","outlined-white":"Button_outlined-white__e2mUt"};